import api from './api.service';
import type { HelpGuideListItem, HowToGuidePayload } from '@/types/help-guide';

type ListBody = {
  success?: boolean;
  message?: string;
  total?: number;
  guides?: HelpGuideListItem[];
  modules?: Array<{ key: string; label: string; count: number }>;
};

type DetailBody = {
  success?: boolean;
  message?: string;
  guide?: HowToGuidePayload;
  answerText?: string;
  phrases?: string[];
};

export const helpGuideService = {
  async list(params?: { q?: string; module?: string }) {
    const q = new URLSearchParams();
    if (params?.q) q.set('q', params.q);
    if (params?.module) q.set('module', params.module);
    const qs = q.toString();
    const body = (await api.get(`/ai-agent/help/guides${qs ? `?${qs}` : ''}`)) as unknown as ListBody;
    if (!body?.guides) throw new Error(body?.message || 'Could not load guides');
    return { guides: body.guides, modules: body.modules ?? [], total: body.total ?? body.guides.length };
  },

  async get(id: string) {
    const body = (await api.get(`/ai-agent/help/guides/${encodeURIComponent(id)}`)) as unknown as DetailBody;
    if (!body?.guide) throw new Error(body?.message || 'Guide not found');
    return { guide: body.guide, answerText: body.answerText ?? '', phrases: body.phrases ?? [] };
  },
};
